import { Portal } from 'components/utility/portal'
import React, { useCallback, useEffect, useRef, useState } from 'react'

export default function Drawer({ isOpen, onClose, closable, children }) {
  const [open, setOpen] = useState(false)
  const [visible, setVisible] = useState(false)

  const animateOutTimerRef = useRef()
  const animateStartTimerRef = useRef()

  const clearTimers = useCallback(() => {
    if (animateOutTimerRef.current) clearTimeout(animateOutTimerRef.current)
    if (animateStartTimerRef.current) cancelAnimationFrame(animateStartTimerRef.current)
  }, [])

  useEffect(() => {
    if (isOpen) {
      clearTimers()
      setOpen(isOpen)
      animateStartTimerRef.current = requestAnimationFrame(() => {
        setVisible(true)
      })
    } else {
      setOpen(false)
      animateOutTimerRef.current = setTimeout(() => {
        setVisible(false)
      }, 500)
    }
  }, [isOpen, clearTimers])

  if (!isOpen && !visible) return null

  return (
    <Portal>
      <div className="toc-drawer" style={{ pointerEvents: closable ? 'auto' : 'none' }}>
        <div
          aria-expanded={open}
          className="toc-drawer-overlay"
          style={{ pointerEvents: closable ? 'auto' : 'none' }}
          onClick={() => {
            if (closable) onClose()
          }}
        ></div>
        <div aria-expanded={open} className="toc-drawer-container" style={{ pointerEvents: 'auto' }}>
          {children}
        </div>
      </div>
    </Portal>
  )
}
